import React, { ComponentType } from 'react';
import { PowerEditorBaseProps, PowerEditorBase } from '../../toolympus/components/PowerDoc';
import { PowerEditorSettingsProvider } from '../../toolympus/components/PowerDoc/PowerEditorSettingsContext';
import { ColumnsPlugin } from '../../toolympus/components/PowerDoc/plugins/Columns';
import { ExpanderPlugin } from '../../toolympus/components/PowerDoc/plugins/Expander';
import { useMediaFilesPlugin } from '../../toolympus/components/PowerDoc/plugins/MediaFiles';
import { PanelPlugin } from '../../toolympus/components/PowerDoc/plugins/Panel/PanelPlugin';
import { TablesPlugin } from '../../toolympus/components/PowerDoc/plugins/Tables';
import { MediaLibProvider } from '../../toolympus/components/medialib';
import { RenderElementProps } from 'slate-react';
import { useCustomFieldsViewerPlugin } from '../../toolympus/components/PowerDoc/plugins/CustomFieldsBlock';
import { ScriptInjectPlugin } from '../../toolympus/components/PowerDoc/plugins/Script/ScriptInjectPlugin';

interface Props extends Omit<PowerEditorBaseProps, "update"> {
  customBlocks?: Record<string, ComponentType<RenderElementProps>>;
}


export const PageViewer = (props: Props) => {
  return <MediaLibProvider spaceId="2" apiPath="/api/medialib" getFilepath={mf => `/cms-media/${mf.filename}`} noLoad>
    <PowerEditorSettingsProvider EditorComponent={PageViewerUnwrapped}>
      <PageViewerUnwrapped {...props} />
    </PowerEditorSettingsProvider>
  </MediaLibProvider>
}

export const PageViewerUnwrapped = (props: Props) => {
  const mediaFilesPlugin = useMediaFilesPlugin();
  const customBlocksPlugin = useCustomFieldsViewerPlugin(props.customBlocks || {});

  return (
    <PowerEditorBase
        {...props}
        update={() => {}}
        placeholder=" "
        viewMode
        plugins={[
            mediaFilesPlugin,
            customBlocksPlugin,
            ColumnsPlugin,
            PanelPlugin,
            ScriptInjectPlugin,
            ExpanderPlugin,
            TablesPlugin,
        ]}
        />
  );
}
